{
  "incidentsOverview": {
    "button": {
      "new": "Nuovo evento valanghivo",
      "columns": "Colonne",
      "download": "Scarica GeoJSON"
    },
    "tooltip": {
      "edit": "Modifica evento valanghivo",
      "preview": "Visualizza l'evento valanghivo"
    },
    "empty": "Nessun evento valanghivo in questa meteo-nivo zona.",
    "loading": "Caricamento eventi valanghivi...",
    "error": "Il caricamento degli eventi valanghivi non è stato possibile",
    "retry": "Riprova",
    "filter": {
      "anyStatus": "Qualsiasi status"
    }
  },
  "incidentReportUI": {
    "addAttachment": "Aggiungi allegato",
    "addAvalancheProblem": "Aggiungi problema valanghivo",
    "addGroup": "Aggiungi gruppo",
    "addVictim": "Aggiungi persona",
    "back": "Indietro",
    "clearLine": "Cancella linea",
    "clearPoint": "Cancella punto",
    "clearPolygon": "Cancella poligono",
    "controls": "Regolazione geometria",
    "deleteIncident": "Cancella evento valanghivo",
    "deleteIncidentConfirm": "Vuoi cancellare questo evento valanghivo?",
    "drawLine": "Disegna linea",
    "drawLineInstructions": "Clicca sulla mappa per aggiungere punti alla linea.",
    "drawPoint": "Disegna punto",
    "drawPointInstructions": "Clicca in un punto qualsiasi della mappa per posizionare l'indicatore di posizione, quindi trascinalo per riposizionarlo.",
    "drawPolygon": "Disegna poligono",
    "drawPolygonInstructions": "Clicca sulla mappa per definire gli angoli/i vertici del poligono.",
    "dropAttachment": "Rimuovere l'allegato {{fileName}}?",
    "dropAvalancheProblem": "Elimina problema valanghivo {{numero}}?",
    "dropGroup": "Rimuovere il gruppo {{number}}?",
    "dropVictim": "Rimuovere la persona {{number}}?",
    "fetchPublishedBulletin": "Recupera dal bollettino CAAML pubblicato",
    "fetchPublishedBulletinError": "Nessun bollettino CAAML pubblicato poteva essere recuperato per {{region}} il {{date}}.",
    "fetchPublishedBulletinSuccess": "Bollettino con informazioni aggiornate con {{count}} problemi valanghivi per {{region}} il {{date}}.",
    "groupName": "Gruppo {{name}}",
    "groupUnknown": "Gruppo sconosciuto",
    "incomplete": "Incompleto",
    "line": "Linea",
    "locationMap": "Mappa di localizzazione",
    "noGroups": "Non sono registrati dei gruppi. Clicca su \"Aggiungi gruppo\" per creare un gruppo.",
    "next": "Successivo",
    "overview": "Panoramica",
    "noVictims": "Nessuna persona registrata. Clicca su \"Aggiungi persona\" per creare una persona.",
    "point": "Punto",
    "polygon": "Poligono",
    "publishIncident": "Pubblicare",
    "publishIncidentConfirm": "Vuoi pubblicare questo evento valanghivo?",
    "publishIncidentSuccess": "Il rapporto sull'evento valanghivo è stato pubblicato con successo.",
    "republishIncident": "Pubblicare di nuovo",
    "republishIncidentConfirm": "Vuoi ripubblicare questo evento valanghivo?",
    "unpublishIncident": "Annullare la pubblicazione",
    "unpublishIncidentConfirm": "Vuoi annullare la pubblicazione di questo evento valanghivo?",
    "unpublishIncidentSuccess": "Il rapporto sull'evento valanghivo è stato annullato con successo.",
    "removeAttachment": "Rimuovere allegato",
    "removeAvalancheProblem": "Cancella problema valanghivo",
    "removeGroup": "Rimuovere gruppo",
    "removeVictim": "Rimuovere persona",
    "requiredFieldsMissingHint": "Non è possibile salvare il rapporto né modificarne lo stato finché non saranno stati compilati tutti i campi obbligatori (contrassegnati nel modulo).",
    "displayMode": {
      "edit": "Modifica",
      "editMostRelevant": "Modifica i risultati più importanti",
      "all": "Anteprima di tutto",
      "public": "Anteprima solo pubblico",
      "filledOut": "Anteprima solo compilato"
    },
    "victimName": "Persona {{name}}",
    "saveStateSaving": "Salvataggio in corso",
    "saveStateSaved": "Salvato con successo",
    "saveStateError": "Salvataggio fallito",
    "saveStateBlocked": "Non salvato - campi obbligatori mancanti"
  },
  "incidentReport": {
    "incidentReport": "Rapporto sull'evento valanghivo",
    "metaInformation": "Informazioni meta",
    "generalInformation": "Informazioni generali",
    "bulletinInformation": "Informazioni dal bollettino",
    "locationInformation": "Informazioni sulla località",
    "avalancheInformation": "Informazioni sulla valanga",
    "groupInformation": "Informazioni sul gruppo",
    "victimInformation": "Informazioni sulla persona",
    "involvementsFatalitiesBurials": "Coinvolgimenti, morti e seppellimenti",
    "incidentAnalysis": "Analisi dell'evento valanghivo",
    "incidentAttachments": "Allegati e link",
    "author": "Autore",
    "authorAffiliation": "Organizzazione dell'autore",
    "dateTime": "Data/ora",
    "updatedAt": "Ultimo aggiornamento",
    "publishedAt": "Pubblicato ",
    "timeAccuracy": "Precisione dell'orario",
    "sourceOfInformation": "Fonte di informazione",
    "personInvolvement": "Coinvolgimento di persone",
    "otherDamages": "Altri danni",
    "damagedAssets": "Oggetti danneggiati",
    "otherDamagesComment": "Commenti riguardo agli altri danni ",
    "publicAvalancheWarningService": "Servizio Valanghe ufficiale",
    "publicAvalancheWarningServiceOutside": "Al di fuori dell'area di previsione del Servizio Valanghe",
    "dangerRating": "Grado di pericolo",
    "avalancheProblem": "Problema valanghivo",
    "problemType": "Problema valanghivo",
    "aspects": "Esposizioni",
    "elevationLowerBound": "Limite inferiore quota",
    "elevationUpperBound": "Limite superiore quota",
    "snowpackStability": "Stabilità del manto nevoso",
    "frequency": "Frequenza",
    "dangerPattern": "Situazione tipo",
    "reportStatus": "Stato del bollettino",
    "publicExternalLinks": "Link esterni pubblici",
    "privateExternalLinks": "Link esterni privati",
    "privateExternalDatabaseLinks": "Link a banche dati esterne",
    "generalInformationComment": "Commento sulle informazioni generali",
    "bulletinInformationComment": "Commento sulle informazioni del bollettino",
    "location": "Località",
    "country": "Stato",
    "region": "Meteo-nivo zona",
    "municipality": "Comune",
    "avalancheRegion": "Meteo-nivo zona",
    "latitude": "Latitudine",
    "longitude": "Longitudine",
    "locationAccuracy": "Precisione di localizzazione",
    "lineCoordinatesText": "Coordinate della linea",
    "polygonCoordinatesText": "Coordinate del poligono",
    "locationInformationComment": "Commento sulle informazioni relative alla località",
    "locationType": {
      "Point": "Punto",
      "Line": "Linea",
      "Polygon": "Poligono"
    },
    "anonymousGroupIdentifier": "Identificatore di gruppo anonimo",
    "groupAffiliation": "Appartenenza a un gruppo",
    "groupType": "Tipo di gruppo",
    "groupSize": "Dimensione del gruppo",
    "groupSizeAccuracy": "Precisione della dimensione del gruppo",
    "incidentTerrainType": "Tipo di terreno",
    "typeOfControlledTerrain": "Tipo di zona controllata",
    "incidentActivity": "Attività",
    "travelDirection": "Direzione di movimento",
    "vehicleType": "Tipo di veicolo",
    "avalancheGear": "Attrezzatura d'emergenza",
    "groupInformationComment": "Commento sulle informazione relative al gruppo",
    "numberOfGroups": "Numero di gruppi",
    "activities": "Attività",
    "terrainTypes": "Tipi di terreno",
    "fatalities": "Morti",
    "injuredSurvivors": "Sopravvissuti feriti",
    "uninjuredSurvivors": "Sopravvissuti illesi",
    "caughtOnly": "Solo travolti",
    "fullyBuried": "Completamente seppelliti",
    "partlyBuriedHeadCovered": "Parzialmente seppelliti, testa coperta",
    "partlyBuriedHeadUncovered": "Parzialmente seppelliti, testa libera",
    "partlyBuried": "Parzialmente seppellito",
    "numberInvolved": "Numero persone coinvolte",
    "involvementsFatalitiesBurialsComment": "Commento riguardo a persone coinvolte, morte e seppellite",
    "caught": "Trascinati",
    "fatalInjured": "Morti/feriti",
    "burialDegree": "Grado di seppellimento",
    "anonymousVictimIdentifier": "Identificatore di persona anonimo",
    "age": "Età",
    "gender": "Sesso",
    "workingAtTime": "Incidente durante il lavoro",
    "leaderAtTime": "Sul campo come guida",
    "professionalCertification": "Qualifica professionale",
    "avalancheTraining": "Formazione sul tema valanghe",
    "yearsActive": "Anni di attività",
    "transceiver": "Dispositivo di ricerca in valanga (ARTVA)",
    "shovel": "Pala",
    "probe": "Sonda",
    "airbag": "Airbag",
    "helmet": "Casco",
    "terrainTrap": "Trappola morfologica",
    "burialDepth": "Profondità di seppellimento",
    "burialDuration": "Durata del seppellimento",
    "primaryLocationMethod": "Metodo di localizzazione primario",
    "rescuedBy": "Rescued/Recovered by",
    "medicalIntervention": "Intervento medico",
    "estimatedTimeOfDeath": "Ora stimata del decesso ",
    "causeOfDeath": "Causa del decesso",
    "respiratoryCavity": "Presenza sacca d'aria",
    "injurySeverity": "Gravità delle ferite",
    "victimInformationComment": "Commento riguardo alle informazioni sulla vittima",
    "multipleAvalanches": "Valanghe multiple",
    "avalancheSize": "Dimensione valanga",
    "avalancheType": "Tipo di valanga",
    "relevantAvalancheProblem": "Problema valanghivo rilevante",
    "trigger": "Fattore provocante il distacco",
    "natural": "Spontaneo",
    "person": "Persona",
    "additionalLoad": "Sovraccarico",
    "explosives": "Distacco artificiale",
    "vehicle": "Veicolo",
    "accidentalControlled": "Accidentale/controllato",
    "remoteTriggering": "Distacco a distanza",
    "startZoneAspect": "Esposizione della zona di distacco",
    "startZoneAspectAccuracy": "Precisione dell'esposizione",
    "startZoneElevation": "Altitudine s.l.m. della zona di distacco",
    "startZoneElevationAccuracy": "Precisione dell'altitudine s.l.m.",
    "startZoneIncline": "Inclinazione della zona di distacco",
    "startZoneTerrainType": "Tipo di terreno nella zona di distacco",
    "slabWidth": "Larghezza del lastrone",
    "crownDepthAvg": "Spessore medio della frattura",
    "crownDepthMin": "Spessore minimo della frattura",
    "crownDepthMax": "Spessore massimo della frattura",
    "avalancheLength": "Lunghezza della valanga",
    "weakLayerName": "Denominazione dello strato debole",
    "weakLayerGrainType1": "Forma dei grani (1) dello strato debole",
    "weakLayerGrainSize1": "Dimensione dei grani (1) dello strato debole",
    "weakLayerGrainType2": "Forma dei grani (2) dello strato debole",
    "weakLayerGrainSize2": "Dimensione dei grani (2) dello strato debole",
    "weakLayerLocation": "Posizione dello strato debole nel manto nevoso",
    "bedSurfaceStepped": "Collasso in strati più profondi",
    "startZoneMoisture": "Umidità nella zona di distacco",
    "depositMoisture": "Umidità nel deposito",
    "depositHeight": "Altezza del deposito",
    "depositWidth": "Larghezza del deposito",
    "debrisType": "Tipo di deposito",
    "debrisDensity": "Densità del deposito",
    "depositElevation": "Altitudine s.l.m. del deposito",
    "avalancheDetailsComment": "Commento riguardo ai dettagli sulla valanga",
    "incidentLedePublic": "Pubblicare breve riassunto dell'evento valanghivo?",
    "incidentLede": "Riassunto dell'evento valanghivo",
    "incidentDescriptionPublic": "Pubblicare descrizione dell'evento?",
    "incidentDescription": "Descrizione dell'evento",
    "weatherDescriptionPublic": "Pubblicare descrizione meteo?",
    "weatherDescription": "Descrizione meteo",
    "avalancheDescriptionPublic": "Pubblicare la descrizione della valanga?",
    "avalancheDescription": "Descrizione della valanga",
    "snowpackDescriptionPublic": "Pubblicare la descrizione del manto nevoso?",
    "snowpackDescription": "Descrizione del manto nevoso",
    "takeAwaysPublic": "Pubblicare le conclusioni principali?",
    "takeAways": "Conclusioni principali",
    "recentSlabAvalanches": "Valanghe di neve a lastroni recenti",
    "signsOfInstability": "Segnali d'allarme",
    "recentLoading": "Sovraccarico recente",
    "criticalWarming": "Riscaldamento critico",
    "incidentAnalysisComment": "Commento riguardo all'analisi dell'evento",
    "uuid": "UUID",
    "dateAdded": "Data aggiunta",
    "dateCreated": "Data creata",
    "file": "File",
    "fileName": "Nome del file",
    "mediaType": "Tipo di media",
    "attachmentTags": "Tag",
    "altText": "Testo alternativo",
    "credit": "Credito fotografico",
    "caption": "Didascalia",
    "public": "Pubblico",
    "attachmentCategory": "Categoria"
  },
  "incidentReportHelp": {
    "author": "",
    "authorAffiliation": "",
    "dateTime": "",
    "timeAccuracy": "Specifica la precisione della data e dell'ora della valanga.",
    "sourceOfInformation": "Specifica la fonte/le fonti dell'informazione.",
    "personInvolvement": "Seleziona “Sì” se la valanga è stata provocata da persone (compreso il distacco a distanza) o se alcune persone sono state travolte dalle masse in movimento.",
    "otherDamages": "Seleziona “Sì” se la valanga ha causato danni a beni immobili o ad altri oggetti di valore.",
    "damagedAssets": "Indica il tipo di oggetto/i che ha/hanno subito danni.",
    "otherDamagesComment": "Aggiungi dettagli supplementari sui beni danneggiati.",
    "publicAvalancheWarningService": "Nome dell'organizzazione nell'ambito di competenza del quale si è verificata la valanga.",
    "publicAvalancheWarningServiceOutside": "Seleziona questa casella se l'evento si è verificato al di fuori dell'area di previsione di un servizio valanghe.",
    "dangerRating": "Grado di pericolo valanghe reso pubblico, valido per la data, l’ora e il luogo dell’evento (comprese la fascia altitudinale e l’esposizione, se disponibili).",
    "avalancheProblem": "Seleziona i problemi valanghivi EAWS previsti per quel giorno e in quella località. Seleziona «Nessuno» se per quel giorno non sono stati pubblicati problemi valanghivi.",
    "problemType": "Seleziona i problemi valanghivi EAWS previsti per quel giorno e in quella località. Seleziona «Nessuno» se per quel giorno non sono stati pubblicati problemi valanghivi.",
    "aspects": "",
    "elevationLowerBound": "",
    "elevationUpperBound": "",
    "snowpackStability": "",
    "frequency": "",
    "dangerPattern": "Seleziona le situazioni tipo previste per quel giorno e in quella località.",
    "reportStatus": "Bozza: non ancora rilasciata al pubblico; fase di raccolta iniziale dei dati. Incompleta: non tutte le informazioni sono state inserite o sono già disponibili; visibile al pubblico, ma può contenere informazioni non ancora verificate. In fase di verifica: tutte le informazioni sono state raccolte; in attesa di verifica da parte di un responsabile. Completata: tutte le informazioni disponibili sono state inserite; stato definitivo.",
    "publicExternalLinks": "",
    "privateExternalLinks": "",
    "privateExternalDatabaseLinks": "Collega questo evento ad altri database.",
    "generalInformationComment": "Aggiungi altri dettagli rilevanti.",
    "bulletinInformationComment": "Aggiungi altri dettagli rilevanti.",
    "location": "Breve descrizione del luogo. Utilizza il nome della montagna più vicina o di un elemento geografico caratteristico.",
    "country": "",
    "region": "",
    "municipality": "",
    "avalancheRegion": "Micro zone",
    "latitude": "Indica le coordinate del centro del fronte di distacco.",
    "longitude": "Indica le coordinate del centro del fronte di distacco.",
    "locationAccuracy": "Stima la precisione delle coordinate di latitudine e longitudine.",
    "lineCoordinatesText": "Indica le coordinate della traccia della valanga (una coppia di latitudine e longitudine per riga).",
    "polygonCoordinatesText": "Inserisci le coordinate del contorno della valanga (una coppia di latitudine e longitudine per riga).",
    "locationInformationComment": "Aggiungi altri dettagli rilevanti.",
    "anonymousGroupIdentifier": "Questo codice serve a identificare in modo univoco il gruppo in tutto il rapporto. È possibile, ad esempio, fare riferimento a “Gruppo 1”, “Gruppo 2” e così via. Se lo si ritiene utile, è possibile aggiungere ulteriori dettagli per distinguere meglio i gruppi. Se opportuno, è possibile utilizzare lo stesso codice anonimo anche nella descrizione dell’evento.",
    "groupAffiliation": "Seleziona il gruppo a cui apparteneva quella persona.",
    "groupType": "Seleziona l'opzione che descrive meglio il tipo di gruppo.",
    "groupSize": "Indica il numero complessivo di persone nel gruppo.",
    "groupSizeAccuracy": "Indica quanto è precisa la stima della dimensione del gruppo.",
    "incidentTerrainType": "Seleziona il tipo di terreno in cui si trovavano le persone al momento della valanga. Per «terreno fuori pista» si intendono le aree prive di infrastrutture umane.",
    "typeOfControlledTerrain": "",
    "incidentActivity": "",
    "travelDirection": "Direzione di movimento al momento dell'incidente.",
    "vehicleType": "",
    "avalancheGear": "L'attrezzatura di base per le emergenze da valanga comprende un dispositivo ARTVA, una pala e una sonda. Fornisci una valutazione generale per stabilire se il gruppo abbia portato con sé tale equipaggiamento. Queste informazioni provengono spesso dai soccorritori. Non è necessario effettuare un accertamento del numero esatto delle attrezzature o dello stato dell’equipaggiamento di ogni singola persona. La domanda fondamentale è: il gruppo ha portato con sé l’attrezzatura di soccorso in caso di valanga?",
    "groupInformationComment": "Aggiungi altri dettagli rilevanti.",
    "numberOfGroups": "Numero di gruppi coinvolti.",
    "activities": "",
    "terrainTypes": "",
    "fatalities": "Tutte le persone decedute, indipendentemente dal fatto che siano decedute sul luogo dell’incidente o in seguito alle lesioni riportate.",
    "injuredSurvivors": "Numero di persone travolte dalla valanga e rimaste ferite (esclusi i deceduti).",
    "uninjuredSurvivors": "Numero di persone travolte dalla valanga, ma rimaste illese. Ne fanno parte anche le persone solo raggiunte dalla nube di polvere di neve..",
    "caughtOnly": "Numero di persone travolte dalla valanga, ma non seppellite. Ne fanno parte anche le persone solo raggiunte dalla nube di polvere di neve..",
    "fullyBuried": "Numero di persone completamente seppellite dalla valanga. Quando una persona è completamente seppellita, nessuna parte del suo corpo è visibile.",
    "partlyBuriedHeadCovered": "Numero di persone rimaste sepolte in modo tale che la testa risultava coperta di neve, mentre rimanevano visibili parti del corpo, degli indumenti o dell’equipaggiamento che portavano con sé.",
    "partlyBuriedHeadUncovered": "Numero di persone rimaste sepolte, la cui testa, tuttavia, non era ricoperta di neve.",
    "partlyBuried": "Numero=parzialmente seppelliti, testa coperta+parzialmente seppelliti, testa non coperta",
    "numberInvolved": "Numero=solo trascinati+completamente seppelliti+parzialmente seppelliti",
    "involvementsFatalitiesBurialsComment": "Aggiungi altri dettagli rilevanti.",
    "caught": "Indica se questa persona è stata coinvolta nella valanga. Si considera coinvolta una persona se è stata travolta dalla valanga (seppellita o no), se è rimasta seppellita o se è stata semplicemente investita dalla polvere di neve.",
    "fatalInjured": "indica se la persona è stata ferita mortalmente, è stata ferita o è rimasta illesa, indipendentemente dal modo in cui è stata coinvolta nella valanga.",
    "burialDegree": "indica il grado di seppellimento. Una persona è considerata completamente seppellita se tutto il suo corpo è ricoperto di neve. In caso di seppellimento parziale, se possibile, si dovrebbe specificare se la testa fosse coperta o scoperta; si raccomanda di utilizzare queste opzioni. Se tale informazione non è disponibile, selezioni l’opzione «parzialmente seppellita».",
    "anonymousVictimIdentifier": "Questo codice serve a identificare la vittima nel corso dell’intero rapporto, senza dover ricorrere al suo nome. Ad esempio, nel redigere un rapporto su un incidente con una motoslitta, potreste fare riferimento a Rider 1, Rider 2, ecc. È possibile aggiungere dettagli specifici se ciò aiuta a distinguere le diverse vittime, ad esempio: sopravvissuto di sesso maschile, sopravvissuta di sesso femminile, deceduto di sesso maschile. Se opportuno, potete utilizzare lo stesso identificativo quando fate riferimento a questa persona nella descrizione dell’incidente.",
    "age": "",
    "gender": "",
    "workingAtTime": "Indica se, al momento dell'evento, la persona fosse attiva a livello professionale, sia in una funzione retribuita che nell'ambito di un'attività di volontariato.",
    "leaderAtTime": "La persona coinvolta agiva in una veste che la collocava chiaramente alla guida del gruppo?",
    "professionalCertification": "Indica la qualifica professionale o la certificazione della persona.",
    "avalancheTraining": "Indica il livello di formazione più elevato conseguito in materia di soccorso in caso di valanga.",
    "yearsActive": "Seleziona da quanti anni questa persona praticava l'attività prima dell'evento.",
    "transceiver": "Indica se la persona aveva con sé un dispositivo ARTVA e se questo era impostato sulla modalità di trasmissione.",
    "shovel": "",
    "probe": "",
    "airbag": "",
    "helmet": "",
    "terrainTrap": "Se nell'evento era presente una trappola morfologica, indica di quale si trattava.",
    "burialDepth": "Indica la profondità di seppellimento in metri, con una precisione di 0,1 m. Ai fini della determinazione della profondità di seppellimento, fa fede la distanza tra la superficie della neve e le vie respiratorie della persona sepolta.",
    "burialDuration": "Indica la durata del seppellimento della persona coinvolta in minuti. La durata del seppellimento comprende il periodo che va dal momento in cui la persona è rimasta sepolta fino alla liberazione delle vie respiratorie.",
    "primaryLocationMethod": "Indica il metodo primario utilizzato per localizzare la persona in questione.",
    "rescuedBy": "",
    "medicalIntervention": "Indica quali misure mediche sono state adottate, sia dai membri del gruppo che dai soccorritori.",
    "estimatedTimeOfDeath": "Indica nel modo più preciso possibile quando è deceduta la persona in questione. Questa indicazione non deve necessariamente coincidere con l'ora ufficiale del decesso, poiché in molti casi le persone vengono dichiarate morte solo in ospedale.",
    "causeOfDeath": "Presunta causa della morte",
    "respiratoryCavity": "Vie respiratorie libere",
    "injurySeverity": "Grave: una lesione grave, spesso pericolosa per la vita, che richiede cure mediche immediate e può portare a menomazioni permanenti o alla morte (ad es. fratture ossee, traumi cranici, perdita di coscienza, emorragie gravi). Media: una lesione più grave di una lieve, ma non immediatamente pericolosa per la vita. Di solito è necessario un trattamento medico, ma ci si aspetta un recupero completo senza conseguenze a lungo termine di rilievo (ad es. lussazioni, distorsioni o stiramenti, tagli profondi). Lieve: una lesione di lieve entità che può essere trattata con semplici misure di primo soccorso e non richiede cure mediche professionali (ad es. piccoli tagli, escoriazioni o contusioni).",
    "victimInformationComment": "Aggiungere altri dettagli rilevanti.",
    "multipleAvalanches": "Seleziona “Sì” se l’evento è stato collegato a più valanghe. In questo caso, inserisci i dati relativi alla valanga più rilevante nella sezione “Dettagli valanga” e descrivi le altre valanghe nella sezione “Commenti sulle valanghe”.",
    "avalancheSize": "Valuta il potenziale distruttivo della valanga in base alla zona di deposito e classifica la valanga in base allo standard EAWS. La dimensione 1 è quella più piccola. Le dimensioni intermedie non sono generalmente definite, ma possono essere usate per le valanghe che si collocano tra due dimensioni; in questo caso vengono assegnate alla dimensione inferiore (ad esempio, la dimensione 2,5 viene classificata come dimensione 2).",
    "avalancheType": "Seleziona dalla lista il tipo di valanga in base al meccanismo di distacco. Se corrisponde più di un tipo, scegli quello più adatto e aggiungi ulteriori dettagli nella descrizione dell'evento.",
    "relevantAvalancheProblem": "Seleziona il problema valanghivo più rilevante tra quelli indicati dall'EAWS.",
    "trigger": "Spontaneo: distacco senza l’intervento umano. Persona: distacco causato da una o più persone. Artificiale: distacco per mezzo di esplosivi, artiglieria o gas. Veicolo: distacco innescato da un veicolo (ad es. una macchina battipista o un elicottero). Sconosciuto: la causa del distacco è sconosciuta o non chiara.",
    "natural": "Spontaneo: innescato da eventi meteorologici (ad es. nevicate, vento, temperatura); caduta di cornice: innescata dal crollo spontaneo della cornice; terremoto: innescato da un terremoto; crollo di ghiaccio: innescata dal crollo di ghiaccio; caduta di massi: innescata da un evento di caduta di massi",
    "person": "Accidentale: ad es. sciatore, snowboarder, escursionista o alpinista. Intenzionale: ad es. uno sciatore che provoca deliberatamente il distacco di un pendio o di una cornice mediante ski cutting.",
    "additionalLoad": "Sovraccarico debole: sciatore o snowboarder singolo, gruppi con almeno 10 m di distanza tra le persone o escursionisti singoli con le ciaspole. Sovraccarico forte: gruppo che cammina ravvicinato con meno di 10 m di distanza, persona singola a piedi o sciatori o snowboarder che cadono.",
    "explosives": "",
    "vehicle": "",
    "accidentalControlled": "",
    "remoteTriggering": "Si parla di distacco a distanza quando la valanga si distacca a una certa distanza (di solito più di 5 m) dal punto di distacco presunto. La neve nel punto di distacco vero e proprio non si distacca.",
    "startZoneAspect": "Indica l'esposizione della zona di distacco. Se la valanga si estende su più esposizioni, usa quella media e aggiungi ulteriori dettagli nella descrizione dell'evento.",
    "startZoneAspectAccuracy": "Indica se l'esposizione della zona di distacco è certa o incerta. Si considera incerta se sono possibili scostamenti superiori a ±30°.",
    "startZoneElevation": "Indica la quota della linea di distacco in metri sul livello del mare (m s.l.m.). Utilizza il punto più alto della corona di distacco e arrotonda ai 50 m più vicini (ad es. 2550 m o 2600 m). ",
    "startZoneElevationAccuracy": "",
    "startZoneIncline": "Angolo di pendenza della zona di distacco (°), arrotondato ai 5° più vicini (ad es. 30, 35, 40)",
    "startZoneTerrainType": "Seleziona le caratteristiche del terreno che descrivono la zona di distacco della valanga.",
    "slabWidth": "Larghezza del lastrone di neve in metri. Può essere stimata osservando il terreno oppure determinata cartograficamente usando le coordinate dei fianchi.",
    "crownDepthAvg": "Spessore medio della frattura in cm, misurata in verticale e arrotondata ai 10 cm più vicini. Questo valore può essere stimato in base alle osservazioni sul campo (se viene indicato un solo valore per lo spessore, di solito corrisponde allo spessore medio della frattura) oppure, se possibile, calcolato a base dello spessore minimo e massimo della frattura.",
    "crownDepthMin": "Spessore minimo della frattura in cm, misurata in verticale e arrotondata ai 10 cm più vicini. Questo valore viene solitamente stimato sulla base di osservazioni sul campo.",
    "crownDepthMax": "Spessore massimo della frattura in cm, misurata in verticale e arrotondata ai 10 cm più vicini. Questo valore viene solitamente stimato sulla base di osservazioni sul campo.",
    "avalancheLength": "Lunghezza della zona d'arresto lungo il terreno dal punto più alto del fronte di rottura al punto più basso del deposito (in m). Questo valore può essere stimato in base alle osservazioni sul terreno oppure determinato utilizzando le coordinate cartografate della zona di distacco e del punto finale del deposito.",
    "weakLayerName": "Indica il nome dello strato debole, se noto.",
    "weakLayerGrainType1": "Forma primaria dei grani nello strato debole.",
    "weakLayerGrainSize1": "Arrotonda la dimensione dei grani a 0,25 mm.",
    "weakLayerGrainType2": "Forma secondaria dei grani nello strato debole.",
    "weakLayerGrainSize2": "Arrotonda la dimensione dei grani a 0,25 mm.",
    "weakLayerLocation": "All’interno della neve fresca: lo strato debole si trova all’interno della neve caduta o trasportata di recente, risalente all’attuale periodo di nevicata o di trasporto; all’interfaccia con la neve vecchia: lo strato debole si trova al confine tra neve fresca e neve vecchia (ad es. brina di superficie sulla superficie della neve vecchia prima che venisse ricoperta); all’interno del manto di neve vecchia: lo strato debole si trova nella parte centrale o superiore del manto di neve vecchia; vicino al suolo: lo strato debole si trova nella parte inferiore del manto nevoso, vicino al suolo, ed è tipicamente costituito da grani sfaccettati ben definiti. Le valanghe che si distaccano su questo strato debole spesso lasciano il terreno scoperto.",
    "bedSurfaceStepped": "Seleziona “Sì” se la valanga ha interessato uno strato debole più in profondità.",
    "startZoneMoisture": "",
    "depositMoisture": "",
    "depositHeight": "Altezza massima del deposito",
    "depositWidth": "Larghezza massima del deposito",
    "debrisType": "Seleziona le opzioni che descrivono meglio la composizione del deposito della valanga subito dopo la caduta della valanga.",
    "debrisDensity": "Densità del deposito valanghivo, indicata come mediana di diverse misurazioni effettuate in vari punti della zona di deposito.",
    "depositElevation": "Punto più basso del deposito della valanga in metri sul livello del mare (m s.l.m.).",
    "avalancheDetailsComment": "Aggiungi altri dettagli rilevanti.",
    "incidentLedePublic": "",
    "incidentLede": "Breve descrizione dell'evento (max. 500 caratteri) che ne riassuma le caratteristiche principali. Descrivi cosa è successo, quando e dove si è verificato l'evento e perché è degno di nota. Scrivi in modo conciso e oggettivo, mettendo in evidenza gli aspetti più importanti (ad es. il coinvolgimento di persone, il seppellimento, decessi o circostanze eccezionali).",
    "incidentDescriptionPublic": "",
    "incidentDescription": "Descrivi l'evento in modo chiaro e in ordine cronologico, senza giudicare o attribuire colpe. Indica cosa stava facendo il gruppo al momento dell’evento, dove si trovava (terreno, fascia altitudinale ed esposizione, se note), come è stata innescata la valanga, quante persone sono state coinvolte, sepolte, ferite o hanno perso la vita, chi ha effettuato il soccorso e come si è svolto. Aggiungi inoltre tutte le altre osservazioni rilevanti che contribuiscono alla comprensione e alla ricostruzione dell’evento.",
    "weatherDescriptionPublic": "",
    "weatherDescription": "Descrivi le condizioni meteorologiche che hanno influito sul distacco della valanga. Concentrati in particolare su fattori come la formazione dello strato debole, lo sviluppo del lastrone di neve, il sovraccarico più recente sul manto nevoso o il riscaldamento. Se necessario, rimanda agli allegati pertinenti (ad es. dati delle stazioni meteorologiche o grafici).",
    "avalancheDescriptionPublic": "",
    "avalancheDescription": "Descrivi la valanga (o le valanghe) in modo oggettivo, usando termini chiari e precisi. Indica il tipo di valanga, le dimensioni e le misure (ad es. larghezza, spessore della frattura e distanza d'arresto). Descrivi inoltre cosa ha provocato la valanga (spontanea, causata da persone, distacco a distanza) e come si è sviluppata (ad es. propagazione della rottura o espansione). Aggiungi tutte le caratteristiche misurabili o osservate. Nella descrizione dell’evento vanno incluse anche le informazioni su come e dove sono state travolte delle persone, oltre ai dettagli sul soccorso.",
    "snowpackDescriptionPublic": "",
    "snowpackDescription": "Descrivi la struttura e le caratteristiche del manto nevoso che hanno contribuito al distacco di valanga. Concentrati sugli strati deboli rilevanti e sulle caratteristiche del lastrone di neve, descrivendone la distribuzione (ad es. in base alla fascia altitudinale o all’esposizione). Indica i segnali di allarme presenti e i risultati disponibili delle analisi del manto nevoso. L’obiettivo principale dovrebbe essere quello di spiegare il motivo per cui il manto nevoso aveva una elevata suscettibilità al distacco.",
    "takeAwaysPublic": "",
    "takeAways": "Riassumi i punti chiave dell'evento in pochi brevi punti chiave. Ad esempio, parla dei segnali di allarme, della gestione del rischio (ad es. scendere uno alla volta), dell'uso dell'attrezzatura di emergenza in caso di valanghe, delle trappole morfologiche o della composizione del gruppo.",
    "recentSlabAvalanches": "Rispondi alla domanda nella maniera più accurata possibile: nella meteo-nivo zona ci sono indizi per valanghe di neve a lastroni di oggi o di ieri? Tieni conto delle informazioni fornite dallo stesso gruppo coinvolto, dei resoconti delle squadre di soccorso o delle osservazioni di altre persone presenti nella zona, che possano indicare se sono state rilevate altre valanghe.",
    "signsOfInstability": "Rispondi alla domanda secondo la migliore valutazione possibile: ci sono indicazioni di un manto nevoso instabile, come rumori di assestamento (“whumpf”), formazione di crepe o suoni sibilanti? Tieni conto delle informazioni del gruppo interessato stesso, delle segnalazioni dei soccorritori o delle osservazioni di altre persone nella zona che indichino tali segnali di instabilità.",
    "recentLoading": "Rispondi alla domanda secondo la migliore valutazione possibile: nelle ultime 48 ore c’è stato un sovraccarico del manto nevoso, ad esempio a causa di circa 30 cm o più di neve fresca, di notevoli accumuli di neve ventata o di pioggia?",
    "criticalWarming": "Rispondi alla domanda secondo la migliore valutazione possibile: negli ultimi tempi si è verificato un rapido aumento della temperatura fino a valori prossimi a 0 °C oppure lo strato superficiale del manto nevoso risulta bagnato a causa del forte irraggiamento solare, di temperature sopra lo zero o della pioggia?",
    "incidentAnalysisComment": "Ulteriori informazioni",
    "uuid": "UUID",
    "dateAdded": "La data viene presa dall'ora in cui è stato caricato l'allegato.",
    "dateCreated": "Data in cui l'allegato è stato creato o acquisito",
    "file": "File",
    "fileName": "Viene ripreso dal nome originale del file dell'allegato caricato",
    "mediaType": "",
    "attachmentTags": "",
    "altText": "",
    "credit": "",
    "caption": "",
    "public": "",
    "attachmentCategory": ""
  },
  "sourceOfInformation": {
    "PublicObservation": "Osservazione pubblica",
    "AWSInternal": "Uso interno Servizio Valanghe",
    "AWSObserver": "Osservatore Servizio Valanghe",
    "DispatchCentre": "Centrale operativa",
    "Police": "Polizia",
    "MountainRescue": "Soccorso alpino",
    "Other": "Altro"
  },
  "personInvolvement": {
    "Yes": "Evento con coinvolgimento di persone",
    "No": "Evento senza coinvolgimento persone",
    "Unknown": "Evento (sconosciuto)"
  },
  "otherDamages": {
    "Yes": "Sì",
    "No": "No"
  },
  "damagedAssets": {
    "Vehicle": "Veicolo",
    "Forest": "Bosco",
    "Agriculture": "Agricoltura",
    "Livestock": "Bestiame",
    "UtilitiesTechnicalInfrastructure": "Infrastrutture tecniche o servizi di pubblica utilità",
    "ResidentialBuilding": "Residential Building",
    "Other": "Altro"
  },
  "timeAccuracy": {
    "exact": "esatto",
    "PT15M": "± 15 min",
    "PT30M": "± 30 min",
    "PT1H": "± 1 h",
    "PT2H": "± 2 h",
    "PT4H": "± 4 h",
    "PT6H": "± 6 h",
    "PT12H": "± 12 h",
    "P1D": "± 1 d",
    "P2D": "± 2 d",
    "P3D": "± 3 d",
    "unknown": "sconosciuto"
  },
  "reportStatus": {
    "Draft": "Bozza",
    "Incomplete": "Incompleto",
    "InReview": "In revisione",
    "Verified": "Verificato"
  },
  "locationAccuracy": {
    "exact": "esatto",
    "within15m": "± 15 m",
    "within30m": "± 30 m",
    "within100m": "± 100 m",
    "within250m": "± 250 m",
    "within500m": "± 500 m",
    "within1km": "± 1 km",
    "within2km": "± 2 km",
    "within5km": "± 5 km",
    "within10km": "± 10 km",
    "within20km": "± 20 km",
    "within50km": "± 50 km",
    "unknown": "sconosciuto"
  },
  "groupType": {
    "RecreationalFamilyFriends": "Tempo libero famiglia/amici",
    "Club": "Associazione",
    "Commercial": "Commerciale",
    "Industrial": "Industriale",
    "Solo": "Solo",
    "Unknown": "Sconosciuto",
    "Other": "Altro"
  },
  "groupSizeAccuracy": {
    "Exact": "Esatto",
    "Approximately": "All'incirca",
    "AtLeast": "Almeno",
    "Unknown": "Sconosciuto"
  },
  "incidentTerrainType": {
    "FreeTerrain": "Fuori pista",
    "ControlledTerrainOpen": "Zone controllate: aperte",
    "ControlledTerrainClosed": "Zone controllate: chiuse",
    "Unknown": "Sconosciuto"
  },
  "typeOfControlledTerrain": {
    "IndoorInsideBuilding": "All'interno (di un edificio)",
    "Street": "Strada",
    "TrainTrack": "Binari del treno",
    "SkiAreaResort": "Comprensorio sciistico",
    "CrossCountryTrack": "Pista da fondo",
    "SledgingTrack": "Pista da slittino",
    "Other": "Altro"
  },
  "incidentActivity": {
    "Touring": "Escursione sciistica",
    "Freeriding": "Freeriding",
    "SkiingSnowboarding": "Sciare/snowboard",
    "Snowmobiling": "Motoslitta",
    "Mountaineering": "Alpinismo",
    "IceClimbing": "Arrampicata su ghiaccio",
    "Snowshoeing": "Escursioni con le ciaspole",
    "HikingOnFoot": "Escursione a piedi",
    "CrossCountrySkiing": "Sci da fondo",
    "HuntingFishing": "Caccia/pesca",
    "Sledging": "Andare in slittino",
    "Snowbiking": "Snowbiking",
    "Biking": "Andare in bici",
    "InsideVehicle": "All'interno di un veicolo",
    "Unknown": "Sconosciuto",
    "Other": "Altro"
  },
  "travelDirection": {
    "Ascending": "In salita",
    "Descending": "In discesa",
    "Stationary": "Fermo",
    "Traversing": "Attraversando",
    "MovingOnPeaksRidges": "Muovendosi in vetta/cresta",
    "SnowmobileHighMarking": "Snowmobile High Marking",
    "CrossingRunouts": "Attraversando zone d'arresto",
    "Other": "Altro"
  },
  "vehicleType": {
    "Car": "Autovettura",
    "Bus": "Autobus",
    "SnowPlower": "Spazzaneve",
    "Snowcat": "Macchina battipista",
    "Other": "Altro"
  },
  "avalancheGear": {
    "All": "Tutti",
    "Some": "Alcuni",
    "None": "Nessuno",
    "Unknown": "Sconosciuto"
  },
  "natural": {
    "Natural": "Spontaneo (dovuto a eventi atmosferici, ad es. neve fresca, vento, temperatura)",
    "CorniceFall": "Crollo di cornice, spontaneo",
    "Earthquake": "Terremoto",
    "IceFall": "Crollo di seracco",
    "RockFall": "Caduta di massi"
  },
  "person": {
    "PersonAccidental": "Accidentale",
    "PersonControlled": "Controllato"
  },
  "explosives": {
    "Artillery": "Artiglieria",
    "CaseCharge": "Carica esplosiva (in sacco) posizionata al piede del pendio",
    "CorniceControlledByExplosives": "Cornice distaccata con esplosivi",
    "HelicopterDeployedGasExploder": "Esploditore a gas trasportato da elicottero (es. DaisyBell)",
    "HandThrownOrPlaced": "Carica esplosiva lanciata o posizionata a mano",
    "GasExploder": "Esploditore a gas",
    "HelicopterBomb": "Carica esplosiva sganciata da elicottero",
    "Avalauncher": "Avalauncher e altri dispositivi di lancio",
    "PrePlacedRemotelyDetonated": "Carica esplosiva preposizionata e detonata a distanza",
    "TramOrRopewayDelivery": "Sistema di trasporto a fune",
    "Other": "Altro"
  },
  "vehicle": {
    "OverSnowVehicle": "Veicoli per la circolazione su neve (gatti delle nevi, mezzi di manutenzione, ecc.)",
    "Snowmobile": "Motoslitta",
    "Helicopter": "Elicottero (ad esempio durante l'atterraggio o l'avvicinamento)",
    "Other": "Altro"
  },
  "startZoneElevationAccuracy": {
    "exact": "esatto",
    "within50m": "± 50 m",
    "within100m": "± 100 m",
    "within200m": "± 200 m",
    "unknown": "sconosciuto"
  },
  "startZoneTerrainType": {
    "AlpineBowl": "Circo glaciale",
    "Couloir": "Canalone",
    "NearRidgeCrest": "In vicinanza delle creste",
    "SparselyTreed": "Bosco rado",
    "OpenForest": "Bosco aperto",
    "DenseForest": "Bosco fitto",
    "ForestGlade": "Radura",
    "Glacier": "Ghiacciaio",
    "OpenSlope": "Pendio aperto",
    "Ridge": "Cresta",
    "ExtremeRockyTerrain": "Terreno roccioso",
    "BaseOfRockFace": "Piede della parete rocciosa",
    "WoodPath": "Sentiero forestale",
    "LeewardSlope": "Pendio sottovento",
    "WindwardSlope": "Pendio sopravento",
    "IceWaterfall": "Cascata di ghiaccio",
    "Other": "Altro"
  },
  "weakLayerLocation": {
    "WithinNewSnow": "All'interno della neve fresca",
    "AtInterfaceWithOldSnow": "All'interfaccia con la neve vecchia",
    "WithinOldSnowpack": "All'interno della neve vecchia",
    "NearTheGround": "Nello strato basale"
  },
  "debrisType": {
    "Fine": "Fine",
    "Blocks": "A blocchi",
    "Hard": "Dura",
    "Soft": "Morbida",
    "Rocks": "Pietre",
    "Trees": "Alberi",
    "Other": "Altro"
  },
  "startZoneMoisture": {
    "Dry": "Secca",
    "Moist": "Umida",
    "Wet": "Bagnata",
    "Unknown": "Sconosciuto"
  },
  "depositMoisture": {
    "Dry": "Secca",
    "Moist": "Umida",
    "Wet": "Bagnata"
  },
  "bedSurfaceStepped": {
    "Yes": "Sì",
    "No": "No"
  },
  "multipleAvalanches": {
    "Yes": "Sì",
    "No": "No"
  },
  "avalancheType": {
    "slab": "lastrone",
    "loose": "a debole coesione",
    "glide": "slittamento",
    "cornice": "cornice",
    "unknown": "sconosciuto"
  },
  "avalancheSize": {
    "small": "piccola",
    "small_medium": "piccolo-medio",
    "medium": "media",
    "medium_large": "medio - grande",
    "large": "grande",
    "large_very_large": "grande - molto grande",
    "very_large": "molto grande",
    "very_large_extreme": "molto grande - estremamente grand",
    "extreme": "estremamente grande",
    "unknown": "sconosciuto"
  },
  "trigger": {
    "natural": "Spontaneo",
    "person": "Persona",
    "explosives": "Distacco artificiale",
    "vehicle": "Veicolo",
    "unknown": "Sconosciuto",
    "Other": "Altro"
  },
  "startZoneAspectAccuracy": {
    "Accurate": "Preciso",
    "Uncertain": "Incerto"
  },
  "remoteTriggering": {
    "Yes": "Sì",
    "No": "No"
  },
  "additionalLoad": {
    "High": "Alto",
    "Low": "Basso"
  },
  "accidentalControlled": {
    "Accidental": "Accidentale",
    "Controlled": "Controllato"
  },
  "caught": {
    "Involved": "Coinvolto",
    "NotInvolved": "Non coinvolto",
    "Unknown": "Sconosciuto"
  },
  "fatalInjured": {
    "Fatal": "Fatale",
    "Injured": "Ferito",
    "Uninjured": "Illeso",
    "Unknown": "Sconosciuto"
  },
  "burialDegree": {
    "FullyBuried": "Completamente seppellito",
    "PartlyBuriedHeadCovered": "Parzialmente seppellito, testa coperta",
    "PartlyBuriedHeadUncovered": "Parzialmente seppellito, testa libera",
    "PartlyBuried": "Parzialmente seppellito",
    "NotBuried": "Non seppellito",
    "Unknown": "Sconosciuto"
  },
  "age": {
    "UpTo13": "≤ 13",
    "From14To20": "14–20",
    "From21To30": "21–30",
    "From31To40": "31–40",
    "From41To50": "41–50",
    "From51To60": "51–60",
    "From61To70": "61–70",
    "From71": "≥ 71"
  },
  "gender": {
    "Female": "Femminile",
    "Male": "Maschile",
    "Other": "Altro"
  },
  "country": {
    "Austria": "Austria",
    "Germany": "Germania",
    "Italy": "Italia",
    "Switzerland": "Svizzera",
    "Other": "Altro"
  },
  "workingAtTime": {
    "Yes": "Sì",
    "No": "No"
  },
  "leaderAtTime": {
    "Yes": "Sì",
    "No": "No"
  },
  "professionalCertification": {
    "None": "Nessuno",
    "IFMGAGuide": "Guida UIAGM",
    "FullSkiGuide": "Guida sciistica certificata",
    "SkiInstructor": "Maestro di sci",
    "ApprenticeGuide": "Guida in corso di formazione",
    "AvalancheProfessional": "Esperto professionista in valanghe",
    "AvalancheEducator": "Formatore in sicurezza valanghe",
    "Other": "Altro"
  },
  "avalancheTraining": {
    "None": "Nessuno",
    "Awareness": "Consapevolezza",
    "BasicREC": "Formazione base valanghe livello ricreativo ",
    "AdvancedREC": "Formazione avanzata livello ricreativo",
    "Professional": "Professionista",
    "Other": "Altro"
  },
  "yearsActive": {
    "UpTo2Years": "≤ 2 anni",
    "From3To9Years": "3–9 anni",
    "From10Years": "≥ 10 anni"
  },
  "transceiver": {
    "NoTransceiver": "Senza ARTVA",
    "TransceiverOn": "ARTVA: acceso",
    "TransceiverOff": "ARTVA: spento"
  },
  "shovel": {
    "Yes": "Sì",
    "No": "No"
  },
  "probe": {
    "Yes": "Sì",
    "No": "No"
  },
  "airbag": {
    "NoAirbag": "Senza airbag",
    "AirbagDeployed": "Airbag: attivato",
    "AirbagUndeployed": "Airbag: disattivato"
  },
  "helmet": {
    "Yes": "Sì",
    "No": "No"
  },
  "terrainTrap": {
    "None": "Nessuno",
    "Cliff": "Parete rocciosa",
    "Trees": "Alberi",
    "Gully": "Canalone",
    "Depression": "Conca",
    "Bench": "Ripiano",
    "Boulder": "Masso",
    "CrevasseOrBergschrund": "Crepaccio terminale",
    "Other": "Altro"
  },
  "primaryLocationMethod": {
    "NotBuried": "Non seppellito",
    "SelfExtraction": "Autoestrazione",
    "VisualClues": "Indizi visivi",
    "TransceiverProbeShovel": "ARTVA/sonda/pala",
    "SpotProbing": "Sondaggio a campione",
    "ProbeLine": "Catena di sondaggio",
    "Recco": "Recco",
    "RescueDog": "Cane da valanga",
    "Snowmelt": "Fusione della neve",
    "Other": "Altro"
  },
  "rescuedBy": {
    "Self": "Autosoccorso",
    "Companion": "Soccorso da parte dei compagni",
    "OtherGroup": "Altro gruppo",
    "OrganizedRescue": "Soccorso organizzato",
    "Unknown": "Sconosciuto",
    "Other": "Altro"
  },
  "medicalIntervention": {
    "CPR": "RCP – Rianimazione cardiopolmonare ",
    "ALS": "ALS - Supporto avanzato delle funzioni vitali",
    "ECMO": "ECMO",
    "Other": "Altro"
  },
  "estimatedTimeOfDeath": {
    "DuringTheAvalanche": "Durante la caduta della valanga",
    "DuringBurial": "Durante il seppellimento",
    "OnSiteAfterExtrication": "Sul luogo dell'incidente dopo il recupero",
    "DuringTransport": "Durante il trasporto",
    "InHospital": "In ospedale"
  },
  "causeOfDeath": {
    "Asphyxiation": "Asfissia",
    "TraumaticInjury": "Trauma",
    "Hypothermia": "Ipotermia",
    "Other": "Altro"
  },
  "respiratoryCavity": {
    "Yes": "Sì",
    "No": "No"
  },
  "injurySeverity": {
    "Minor": "Minore",
    "Moderate": "Moderato",
    "Major": "Maggiore"
  },
  "recentSlabAvalanches": {
    "Present": "Presente",
    "Absent": "Assente",
    "Unknown": "Sconosciuto"
  },
  "signsOfInstability": {
    "Present": "Presente",
    "Absent": "Assente",
    "Unknown": "Sconosciuto"
  },
  "recentLoading": {
    "Present": "Presente",
    "Absent": "Assente",
    "Unknown": "Sconosciuto"
  },
  "criticalWarming": {
    "Present": "Presente",
    "Absent": "Assente",
    "Unknown": "Sconosciuto"
  },
  "attachmentTags": {
    "Picture": "Foto",
    "PoliceReport": "Rapporto della polizia",
    "MedicalReport": "Rapporto medico",
    "Other": "Altro"
  },
  "attachmentCategory": {
    "Incident": "Evento valanghivo",
    "Avalanche": "Valanga",
    "Snowpack": "Manto nevoso",
    "Group": "Gruppo",
    "Person": "Persona",
    "Weather": "Meteo"
  }
}
